import React from "react";
import { useNavigate } from "react-router-dom";
import { extras, light, fontStack } from "styles/tokens";
import "./NotFound.css";

const NF_VARS = {
  "--nf-font": fontStack,
  "--nf-surface": light.surface,
  "--nf-text-high": light.textHigh,
  "--nf-text-mid": light.textMid,
  "--nf-border": light.border,
  "--nf-accent": extras.accent.main,
  "--nf-accent-hover": extras.accent.hover,
  "--nf-accent-contrast": extras.accent.contrastText,
  "--nf-radius": `${extras.radius.lg}px`,
  "--nf-radius-btn": `${extras.radius.md}px`,
  "--nf-shadow": extras.shadow.lg,
  "--nf-focus": extras.shadow.focusRing,
};

/**
 * Friendly 404 shown for unknown paths instead of silently redirecting to a
 * (possibly stale-looking) dashboard. `homePath` is the role's home route.
 */
function NotFound({ homePath = "/dashboard" }) {
  const navigate = useNavigate();
  return (
    <div className="nf-root" style={NF_VARS}>
      <div className="nf-card">
        <div className="nf-code">404</div>
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-text">
          The page you&rsquo;re looking for doesn&rsquo;t exist or may have
          moved.
        </p>
        <button
          type="button"
          className="nf-btn"
          onClick={() => navigate(homePath)}
        >
          Back to home
        </button>
      </div>
    </div>
  );
}

export default NotFound;
